import * as yup from 'yup'
import { PackingSlipLineItemKeys } from './stl-packing-slip.js'
import { MakeRequiredAndNullable } from './utils.js'

export const slMunsonPackingSlipFileDataSchema = yup.object().shape({
  buyer: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  slMunsonPackingSlipNumber: yup.string().nullable().optional(),
  customerPoNumber: yup.string().nullable().optional(),
  date: yup.string().nullable().optional(),
  vendor: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  destination: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        [PackingSlipLineItemKeys.itemNumber]: yup.number().nullable().optional(),
        [PackingSlipLineItemKeys.itemName]: yup.string().nullable().optional(),
        [PackingSlipLineItemKeys.description]: yup.string().nullable().optional(),
        [PackingSlipLineItemKeys.itemQty]: yup.string().nullable().optional(),
      }),
    )
    .required(),
  notes: yup.string().nullable().optional(),
  shipVia: yup.string().nullable().optional(),
  footerText: yup.string().nullable().optional(),
})

export type SlMunsonPackingSlipFileData = yup.InferType<typeof slMunsonPackingSlipFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<SlMunsonPackingSlipFileData>

export const slMunsonPackingSlipFileMappings: RequiredFileData = {
  buyer: {
    companyName: '2f00095f-c4fd-4105-a74a-7df6d2c980a8',
    address: 'e8948f8c-0139-4f5b-8605-b96aab4fc01b',
    contactName: '7d6a03c6-ac1a-4bf7-815a-1b21e2f2cc72',
    phoneNumber: '0dca13bc-c232-4b20-bf36-abc53b814875',
    emailAddress: 'a37b4227-977c-489d-9178-e4197fa07239',
  },
  slMunsonPackingSlipNumber: '1b9e0cf8-1030-4b5d-83f0-3bcbea1579be',
  customerPoNumber: '064426be-a2ac-46b4-9e80-346ec7aadd4d',
  date: '473dec8e-ee4b-46cf-a154-e2c4853716dd',
  vendor: {
    companyName: '6e62396a-a50d-4696-89eb-d462dd98c0cd',
    address: '35f11913-4d02-4c78-acb1-7e5c1ac81d57',
    contactName: 'a0c1bf36-7834-4f93-88a4-506793af078c',
    phoneNumber: '4c90db43-163d-4fe4-82df-fea9f1163e45',
    emailAddress: '9c23b081-0adb-41c2-b507-412d5f68a781',
  },
  destination: {
    companyName: 'f753b611-007c-44bc-89d4-5e8567a4c216',
    address: '0c431a93-5355-4fc0-afdd-72eb08aaa224',
    contactName: '55ec4267-5c5f-4db2-9c86-1608347da5b1',
    phoneNumber: '4297d295-74e8-40e0-9da3-a3623166ab66',
    emailAddress: '7138b5f4-9907-4798-8910-b78a9d64e4ae',
  },
  items: [
    {
      itemNumber: null,
      itemName: 'd5b8af77-2687-4412-9a4e-f107f674e4f8',
      description: 'c7b91e2b-d37f-424a-81b8-9acfcd0136e1',
      itemQty: 'bff6769e-1713-43fe-84ce-ca0e5354bc29',
    },
  ],
  notes: '389d3ca4-e50f-47fe-84d8-d651cc4c1c50',
  shipVia: '47d408d3-c08a-46de-8839-64d4369ecb6e',
  footerText: 'ed5e0435-3a9d-4487-969d-1cce922ea68d',
}
